<h4 class="mt-4">Charts</h4>
<hr>
<div class="row">
    <div class="col-md-6 col-sm-12 mb-3">
        <div class="chart-box">
            <h5 class="title two">90th Percentile Response Time</h5>
            <canvas id="trendChart" ngChartjs [datasets]="ninetyPercentile" [chartType]="lineChartType" [options]="options" [labels]="labels" [legend]="true"></canvas>
        </div>
    </div>
    <div class="col-md-6 col-sm-12 mb-3">
        <div class="chart-box">
            <h5 class="title two">Actual Response Time</h5>
            <canvas id="trendChart" ngChartjs [datasets]="actualSla" [chartType]="lineChartType" [options]="optionsSla" [labels]="labels" [legend]="true"></canvas>
        </div>
    </div>

    <div class="col-md-6 col-sm-12 mb-3">
        <div class="chart-box">
            <h5 class="title two">Number of Hits Achieved</h5>
            <canvas id="trendChart" ngChartjs [datasets]="dataHitsPSec" [chartType]="lineChartType" [options]="optionNoOfHits" [labels]="labels" [legend]="true"></canvas>
        </div>
    </div>

    <div class="col-md-6 col-sm-12 mb-3">
        <div class="chart-box">
            <h5 class="title two">Throughput</h5>
            <canvas id="trendChart" ngChartjs [datasets]="throughput" [chartType]="lineChartType" [options]="optionThroughput" [labels]="labels" [legend]="true"></canvas>
        </div>
    </div>
 
</div>
<hr>
<section class="compare-sec">
    <h4 class="mt-3">EndPoint Details of {{results[0]?.name}}</h4>
    <hr>
    <div class="table-responsive queue-table mt-3">
        <table class="table table-sm">
            <thead>
                <tr class="text-center font-bold">
                    <td></td>
                    <td class="text-left">Endpoint</td>
                    <td>Status</td>
                    <td width="13%">Duration</td>
                    <td>Active</td>
                    <td>Users</td>
                    <td>Network Received</td>
                    <td>Network Sent</td>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let result of results">
                    <tr *ngIf="!results || result.performanceEndPointDtos.length === 0">
                        <td>No Data Found</td>
                    </tr>
                    <tr *ngFor="let endpoint of result.performanceEndPointDtos">
                        <td>
                            <a target="_blank" [routerLink]="['/endpoint', endpoint.id]"> <i class="fas fa-link" ngbTooltip="Go to Endpoint"></i></a>
                        </td>
                        <td class="text-left">{{endpoint.name}}</td>
                        <td class="text-center">
                            <img src="/assets/images/performance/completed.png" width="20px" *ngIf="endpoint.status === 'PASSED'" ngbTooltip="{{endpoint.status}}">
                            <img src="/assets/images/performance/failed.png" width="20px" *ngIf="endpoint.status === 'FAILED'" ngbTooltip="{{endpoint.status}}">
                            <img src="/assets/images/performance/pending.png" width="20px" *ngIf="endpoint.status === 'PENDING'" ngbTooltip="{{endpoint.status}}">
                            <img src="/assets/images/performance/abort2.png" width="20px" *ngIf="endpoint.status === 'ABORTED'" ngbTooltip="{{endpoint.status}}">
                            <img src="/assets/images/performance/inprogress.png" width="20px" *ngIf="endpoint.status === 'IN_PROGRESS'" ngbTooltip="{{endpoint.status}}">
                            <img src="/assets/images/performance/scheduled.png" width="20px" *ngIf="endpoint.status === 'SCHEDULED'" ngbTooltip="{{endpoint.status}}">
                        </td>
                        <td class="text-center">{{endpoint.duration}}</td>
                        <td class="text-center">{{endpoint.active}}</td>
                        <td class="text-center">{{endpoint.noOfUsers}}</td>
                        <td class="text-center">{{endpoint.receivedKbPerSecond}}</td>
                        <td class="text-center">{{endpoint.sentKbPerSecond}}</td>
                    </tr>

                </ng-container>
            </tbody>
        </table>
    </div>
</section>